import React, {
    useState
} from "react";

import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import "./ShowFreeResult.css";


function ShowPremiumResult() {

    const navigate = useNavigate();

    const {
        paperId
    } = useParams();

    const location = useLocation();


    /*
    |--------------------------------------------------------------------------
    | Sidebar
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | User Name
    |--------------------------------------------------------------------------
    */

    const name =
        Cookies.get("username") ||
        "Student";


    /*
    |--------------------------------------------------------------------------
    | LOCATION STATE
    |--------------------------------------------------------------------------
    */

    const stateResult =
        location.state?.result || null;


    /*
    |--------------------------------------------------------------------------
    | RESULT DATA
    |--------------------------------------------------------------------------
    |
    | Support both:
    |
    | 1. state.result = result.data
    |
    | 2. state.result = complete API response
    |
    */

    const result =
        stateResult?.data ||
        stateResult ||
        null;


    /*
    |--------------------------------------------------------------------------
    | PAPER DATA
    |--------------------------------------------------------------------------
    */

    const paper =
        location.state?.paper ||
        result?.paper ||
        null;


    /*
    |--------------------------------------------------------------------------
    | DEBUG
    |--------------------------------------------------------------------------
    */

    console.log(
        "=========================================="
    );

    console.log(
        "SHOW PREMIUM RESULT - LOCATION:",
        location
    );

    console.log(
        "SHOW PREMIUM RESULT - STATE:",
        location.state
    );

    console.log(
        "SHOW PREMIUM RESULT - STATE RESULT:",
        stateResult
    );

    console.log(
        "SHOW PREMIUM RESULT - FINAL RESULT:",
        result
    );

    console.log(
        "SHOW PREMIUM RESULT - PAPER:",
        paper
    );

    console.log(
        "=========================================="
    );


    /*
    |--------------------------------------------------------------------------
    | BACK TO PREMIUM MCQ
    |--------------------------------------------------------------------------
    */

    const handleBackToPapers = () => {

        navigate(
            "/premium-mcq"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | PRACTICE AGAIN
    |--------------------------------------------------------------------------
    */

    const handlePracticeAgain = () => {

        if (!paperId) {

            navigate(
                "/premium-mcq"
            );

            return;
        }


        navigate(
            `/premium-mcq/start/${encodeURIComponent(paperId)}`
        );

    };


    /*
    |--------------------------------------------------------------------------
    | RESULT MISSING
    |--------------------------------------------------------------------------
    */

    if (
        !result ||
        !Array.isArray(result.review)
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="dashboard-content py-4 px-3 px-md-4">

                        <div className="show-result-container">

                            <div className="result-empty-box">

                                <div className="result-empty-icon">

                                    <i className="bi bi-file-earmark-x"></i>

                                </div>


                                <h3>
                                    Result Not Found
                                </h3>


                                <p>
                                    Result information is not available.
                                    Please go back to Premium MCQs.
                                </p>


                                <button
                                    type="button"
                                    className="result-back-btn"
                                    onClick={
                                        handleBackToPapers
                                    }
                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Premium MCQs

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | RESULT VALUES
    |--------------------------------------------------------------------------
    */

    const review =
        Array.isArray(result.review)
            ? result.review
            : [];


    const totalQuestions =
        Number(
            result.total_questions ??
            review.length ??
            0
        );


    const correct =
        Number(
            result.correct ??
            0
        );


    const wrong =
        Number(
            result.wrong ??
            result.incorrect ??
            0
        );


    const unanswered =
        Number(
            result.unanswered ??
            result.skipped ??
            0
        );


    const attempted =
        Number(
            result.attempted ??
            (correct + wrong)
        );


    const score =
        Number(
            result.score ??
            0
        );


    const attemptNumber =
        Number(
            result.attempt_number ??
            result.attempt_count ??
            1
        );


    /*
    |--------------------------------------------------------------------------
    | PERCENTAGE
    |--------------------------------------------------------------------------
    |
    | Premium score may contain negative marking.
    | Percentage is calculated from correct answers here,
    | matching the existing result display.
    |
    */

    const percentage =
        totalQuestions > 0
            ? Math.round(
                (
                    correct /
                    totalQuestions
                ) * 100
            )
            : 0;


    /*
    |--------------------------------------------------------------------------
    | PAPER DETAILS
    |--------------------------------------------------------------------------
    */

    const paperName =
        paper?.paper ||
        result?.paper?.paper ||
        `Paper #${paperId}`;


    const subject =
        paper?.subject ||
        result?.paper?.subject ||
        "";


    /*
    |--------------------------------------------------------------------------
    | OPTION NORMALIZER
    |--------------------------------------------------------------------------
    |
    | Converts:
    |
    | A -> A
    | B -> B
    | C -> C
    | D -> D
    |
    | 1 -> A
    | 2 -> B
    | 3 -> C
    | 4 -> D
    |
    */

    const normalizeOption = (
        option
    ) => {

        const value =
            String(
                option ?? ""
            )
                .trim()
                .toUpperCase();


        if (
            value === "A" ||
            value === "1"
        ) {
            return "A";
        }


        if (
            value === "B" ||
            value === "2"
        ) {
            return "B";
        }


        if (
            value === "C" ||
            value === "3"
        ) {
            return "C";
        }


        if (
            value === "D" ||
            value === "4"
        ) {
            return "D";
        }


        return "0";

    };


    /*
    |--------------------------------------------------------------------------
    | GET OPTION TEXT
    |--------------------------------------------------------------------------
    */

    const getOptionText = (
        item,
        option
    ) => {

        const normalized =
            normalizeOption(
                option
            );


        if (
            normalized === "A"
        ) {

            return (
                item?.option1 ||
                ""
            );

        }


        if (
            normalized === "B"
        ) {

            return (
                item?.option2 ||
                ""
            );

        }


        if (
            normalized === "C"
        ) {

            return (
                item?.option3 ||
                ""
            );

        }


        if (
            normalized === "D"
        ) {

            return (
                item?.option4 ||
                ""
            );

        }


        return "";

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION LABEL
    |--------------------------------------------------------------------------
    */

    const getOptionLabel = (
        option
    ) => {

        const normalized =
            normalizeOption(
                option
            );


        if (
            normalized === "A"
        ) {
            return "A";
        }


        if (
            normalized === "B"
        ) {
            return "B";
        }


        if (
            normalized === "C"
        ) {
            return "C";
        }


        if (
            normalized === "D"
        ) {
            return "D";
        }


        return "-";

    };


    /*
    |--------------------------------------------------------------------------
    | CHECK QUESTION STATUS
    |--------------------------------------------------------------------------
    */

    const getQuestionStatus = (
        item
    ) => {

        const selected =
            normalizeOption(
                item?.selected_option
            );


        /*
        | Unanswered
        */

        if (
            selected === "0" ||
            item?.status === "unanswered"
        ) {

            return "unanswered";

        }


        /*
        | Backend is_correct
        */

        if (
            item?.is_correct === true ||
            item?.is_correct === 1 ||
            item?.is_correct === "1"
        ) {

            return "correct";

        }


        /*
        | Backend status
        */

        if (
            item?.status === "correct"
        ) {

            return "correct";

        }


        return "wrong";

    };


    /*
    |--------------------------------------------------------------------------
    | RENDER
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">


            {/* ==========================================================
                SIDEBAR
            =========================================================== */}

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            {/* ==========================================================
                MAIN
            =========================================================== */}

            <main className="dashboard-main">


                {/* HEADER */}

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <div className="dashboard-content py-4 px-3 px-md-4">

                    <div className="show-result-container">


                        {/* ==================================================
                            RESULT HEADER
                        =================================================== */}

                        <div className="result-header-card">

                            <div className="result-header-content">

                                <span className="result-small-title">
                                    PREMIUM MCQ RESULT
                                </span>


                                <h1>

                                    {paperName}

                                </h1>


                                {subject && (

                                    <p>
                                        {subject}
                                    </p>

                                )}


                                <p>

                                    Attempt{" "}

                                    {attemptNumber}

                                    {" "}of 2

                                </p>

                            </div>


                            <div className="result-score-circle">

                                <strong>
                                    {percentage}%
                                </strong>


                                <span>
                                    Percentage
                                </span>

                            </div>

                        </div>



                        {/* ==================================================
                            SUMMARY
                        =================================================== */}

                        <div className="result-summary-grid">


                            {/* TOTAL */}

                            <div className="result-summary-card summary-total">

                                <div className="result-summary-icon">

                                    <i className="bi bi-list-check"></i>

                                </div>


                                <div>

                                    <span>
                                        Total Questions
                                    </span>


                                    <strong>
                                        {totalQuestions}
                                    </strong>

                                </div>

                            </div>



                            {/* CORRECT */}

                            <div className="result-summary-card summary-correct">

                                <div className="result-summary-icon">

                                    <i className="bi bi-check-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Correct
                                    </span>


                                    <strong>
                                        {correct}
                                    </strong>

                                </div>

                            </div>



                            {/* WRONG */}

                            <div className="result-summary-card summary-wrong">

                                <div className="result-summary-icon">

                                    <i className="bi bi-x-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Wrong
                                    </span>


                                    <strong>
                                        {wrong}
                                    </strong>

                                </div>

                            </div>



                            {/* UNANSWERED */}

                            <div className="result-summary-card summary-unanswered">

                                <div className="result-summary-icon">

                                    <i className="bi bi-dash-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Unanswered
                                    </span>


                                    <strong>
                                        {unanswered}
                                    </strong>

                                </div>

                            </div>



                            {/* ATTEMPTED */}

                            <div className="result-summary-card summary-attempted">

                                <div className="result-summary-icon">

                                    <i className="bi bi-pencil-square"></i>

                                </div>


                                <div>

                                    <span>
                                        Attempted
                                    </span>


                                    <strong>
                                        {attempted}
                                    </strong>

                                </div>

                            </div>



                            {/* SCORE */}

                            <div className="result-summary-card summary-score">

                                <div className="result-summary-icon">

                                    <i className="bi bi-award"></i>

                                </div>


                                <div>

                                    <span>
                                        Score
                                    </span>


                                    <strong>

                                        {score}

                                        <small>
                                            {" "}/{" "}
                                            {totalQuestions}
                                        </small>

                                    </strong>

                                </div>

                            </div>

                        </div>



                        {/* ==================================================
                            QUESTION REVIEW
                        =================================================== */}

                        <div className="question-review-section">


                            <div className="question-review-heading">

                                <div>

                                    <span>
                                        QUESTION REVIEW
                                    </span>


                                    <h2>
                                        Review Your Answers
                                    </h2>

                                </div>


                                <div className="review-count">

                                    {review.length}

                                    {" "}

                                    Questions

                                </div>

                            </div>



                            {/* =================================================
                                QUESTIONS
                            ================================================== */}

                            {review.map(
                                (
                                    item,
                                    index
                                ) => {


                                    /*
                                    |--------------------------------------------------
                                    | OPTIONS
                                    |--------------------------------------------------
                                    */

                                    const selectedOption =
                                        normalizeOption(
                                            item?.selected_option
                                        );


                                    const correctOption =
                                        normalizeOption(
                                            item?.correct_option
                                        );


                                    const selectedText =
                                        getOptionText(
                                            item,
                                            selectedOption
                                        );


                                    const correctText =
                                        getOptionText(
                                            item,
                                            correctOption
                                        );


                                    const questionStatus =
                                        getQuestionStatus(
                                            item
                                        );


                                    /*
                                    |--------------------------------------------------
                                    | OPTION LIST
                                    |--------------------------------------------------
                                    */

                                    const options = [
                                        {
                                            key: "A",
                                            text: item?.option1 || ""
                                        },
                                        {
                                            key: "B",
                                            text: item?.option2 || ""
                                        },
                                        {
                                            key: "C",
                                            text: item?.option3 || ""
                                        },
                                        {
                                            key: "D",
                                            text: item?.option4 || ""
                                        }
                                    ];


                                    return (

                                        <div
                                            key={
                                                item?.question_id ??
                                                item?.study_id ??
                                                index
                                            }
                                            className={
                                                `result-question-card ${questionStatus}`
                                            }
                                        >


                                            {/* ====================================
                                                QUESTION TOP
                                            ===================================== */}

                                            <div className="result-question-top">


                                                <div className="result-question-number">

                                                    Q{" "}

                                                    {String(
                                                        index + 1
                                                    ).padStart(
                                                        2,
                                                        "0"
                                                    )}

                                                </div>


                                                <div
                                                    className={
                                                        `question-status-badge ${questionStatus}`
                                                    }
                                                >


                                                    {questionStatus ===
                                                        "correct" && (

                                                        <>

                                                            <i className="bi bi-check-circle-fill"></i>

                                                            Correct

                                                        </>

                                                    )}


                                                    {questionStatus ===
                                                        "wrong" && (

                                                        <>

                                                            <i className="bi bi-x-circle-fill"></i>

                                                            Wrong

                                                        </>

                                                    )}


                                                    {questionStatus ===
                                                        "unanswered" && (

                                                        <>

                                                            <i className="bi bi-dash-circle-fill"></i>

                                                            Unanswered

                                                        </>

                                                    )}

                                                </div>

                                            </div>



                                            {/* ====================================
                                                QUESTION
                                            ===================================== */}

                                            <div
                                                className="result-question-text"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item?.question ||
                                                        ""
                                                }}
                                            />



                                            {/* ====================================
                                                OPTIONS
                                            ===================================== */}

                                            <div className="result-options">


                                                {options.map(
                                                    option => {


                                                        const isSelected =
                                                            selectedOption ===
                                                            option.key;


                                                        const isCorrect =
                                                            correctOption ===
                                                            option.key;


                                                        let optionClass =
                                                            "result-option";


                                                        /*
                                                        | Selected + Correct
                                                        */

                                                        if (
                                                            isSelected &&
                                                            isCorrect
                                                        ) {

                                                            optionClass +=
                                                                " result-option-selected-correct";

                                                        }


                                                        /*
                                                        | Correct answer
                                                        */

                                                        else if (
                                                            isCorrect
                                                        ) {

                                                            optionClass +=
                                                                " result-option-correct";

                                                        }


                                                        /*
                                                        | Selected wrong answer
                                                        */

                                                        else if (
                                                            isSelected
                                                        ) {

                                                            optionClass +=
                                                                " result-option-wrong";

                                                        }


                                                        return (

                                                            <div
                                                                key={
                                                                    option.key
                                                                }
                                                                className={
                                                                    optionClass
                                                                }
                                                            >


                                                                <div className="result-option-letter">

                                                                    {
                                                                        option.key
                                                                    }

                                                                </div>


                                                                <div
                                                                    className="result-option-text"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            option.text
                                                                    }}
                                                                />


                                                                <div className="result-option-status">


                                                                    {isCorrect && (

                                                                        <span className="correct-label">

                                                                            <i className="bi bi-check-circle-fill"></i>

                                                                            Correct Answer

                                                                        </span>

                                                                    )}


                                                                    {isSelected &&
                                                                        !isCorrect && (

                                                                            <span className="wrong-label">

                                                                                <i className="bi bi-x-circle-fill"></i>

                                                                                Your Answer

                                                                            </span>

                                                                        )
                                                                    }


                                                                </div>

                                                            </div>

                                                        );

                                                    }
                                                )}

                                            </div>



                                            {/* ====================================
                                                ANSWER INFORMATION
                                            ===================================== */}

                                            <div className="answer-information">


                                                {/* YOUR ANSWER */}

                                                <div className="answer-info-item">

                                                    <span>
                                                        Your Answer
                                                    </span>


                                                    {selectedOption ===
                                                        "0" ? (

                                                        <strong className="unanswered-text">

                                                            Not Answered

                                                        </strong>

                                                    ) : (

                                                        <strong
                                                            className={
                                                                questionStatus ===
                                                                    "correct"

                                                                    ? "correct-text"

                                                                    : "wrong-text"
                                                            }
                                                        >

                                                            {
                                                                getOptionLabel(
                                                                    selectedOption
                                                                )
                                                            }

                                                            {" - "}

                                                            {
                                                                selectedText
                                                            }

                                                        </strong>

                                                    )}

                                                </div>



                                                {/* CORRECT ANSWER */}

                                                <div className="answer-info-item">

                                                    <span>
                                                        Correct Answer
                                                    </span>


                                                    <strong className="correct-text">

                                                        {
                                                            getOptionLabel(
                                                                correctOption
                                                            )
                                                        }

                                                        {" - "}

                                                        {
                                                            correctText
                                                        }

                                                    </strong>

                                                </div>

                                            </div>



                                            {/* ====================================
                                                EXPLANATION
                                            ===================================== */}

                                            <div className="result-explanation">


                                                <div className="result-explanation-title">

                                                    <i className="bi bi-lightbulb-fill"></i>

                                                    Explanation

                                                </div>


                                                <div
                                                    className="result-explanation-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item?.explanation ||
                                                            "<p>Explanation not available.</p>"
                                                    }}
                                                />

                                            </div>


                                        </div>

                                    );

                                }
                            )}

                        </div>



                        {/* ==================================================
                            ACTION BUTTONS
                        =================================================== */}

                        <div className="result-action-buttons">


                            {attemptNumber < 2 && (

                                <button
                                    type="button"
                                    className="result-practice-btn"
                                    onClick={
                                        handlePracticeAgain
                                    }
                                >

                                    <i className="bi bi-arrow-repeat"></i>

                                    Practice Again

                                </button>

                            )}


                            <button
                                type="button"
                                className="result-back-btn"
                                onClick={
                                    handleBackToPapers
                                }
                            >

                                <i className="bi bi-arrow-left"></i>

                                Back to Premium MCQs

                            </button>

                        </div>


                    </div>

                </div>

            </main>

        </div>

    );

}


export default ShowPremiumResult;